import styled, { css } from 'styled-components';

import { IconNote, IconWarning, mediaMixin, spaceMixin } from '@zillow/constellation';

import Bone from '../../../Bone';

const overlayStyles = css`
  content: '';
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

export const StyledBackgroundImage = styled.div<{
  urlSrc: string;
  hasError: boolean;
  alt: string;
  isDisabled: boolean;
}>`
  align-items: flex-end;
  background-image: url(${(props) => props.urlSrc});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  display: flex;
  height: 90px;
  justify-content: flex-end;
  padding: ${spaceMixin('xs')};
  position: absolute;
  width: 100%;

  ${mediaMixin(
    'lg',
    css`
      height: 100px;
    `,
  )};

  ${(props) =>
    props.hasError &&
    css`
      ::before {
        ${overlayStyles}
        background-color: rgba(255, 255, 255, 0.5);
      }
    `}

  ${(props) =>
    !props.hasError &&
    css`
      ::before {
        ${overlayStyles}
        background-color: rgba(0, 0, 0, 0.2);
      }
    `}
`;

export const StyledIconWarning = styled(IconWarning)`
  z-index: 5;
`;

export const StyledIconNote = styled(IconNote)`
  z-index: 5;
`;

export const StyledBackgroundLoadingImage = styled(Bone)`
  border-radius: 4px;
  height: 90px;
  position: absolute;
  width: 100%;

  ${mediaMixin(
    'lg',
    css`
      height: 100px;
    `,
  )};
`;

export const StyledBackgroundImageContainer = styled.div`
  height: 90px;
  position: relative;
  touch-action: none;

  ${mediaMixin(
    'lg',
    css`
      height: 100px;
    `,
  )};
`;
